// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Xotg","head":"Table_head__Q6PiH","col":"Table_col__2zoOM"};